import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareIssuetypesWorkflowRoute: InvariantJiraRoute = {
	name: 'project-settings-software-issuetypes-workflow',
	path: '/jira/software/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
	exact: true,
};
